<!-- 계약정보 -->
<template>
  <v-container class="vh-footer ps-re lynn-mobile lynn-web-in pd0" fluid>
    <div class="web-side"></div>
    <div class="location-box np">
      <div class="web-logo">
        <Weblogo width="55" height="30" />
      </div>
      <a @click="moveTo('/contract')" class="back">
        <Back />
      </a>
      <strong class="lo-title">계약정보</strong>
    </div>

    <!-- 분양, 계약 구분에 따라 메뉴 변경 -->
    <!-- 분양 -->
    <v-container class="pd0 ps-re" v-if="!home.is_rent">
      <div class="tabs-box">
        <v-tabs
          color="black"
          height="37px"
          style="font-size: 14px"
          v-model="tab"
          background-color="white"
        >
          <v-tab :class="tab_class" :ripple="false" value="0">계약정보 조회</v-tab>
          <v-tab :class="tab_class" :ripple="false" value="1">납부현황 조회</v-tab>
          <v-tab :class="tab_class" :ripple="false" value="2" v-if="!isOptionOnlyVillage">융자현황 조회</v-tab>
          <v-tab :class="tab_class" :ripple="false" value="3" v-if="!isOptionOnlyVillage">대납이자·보증수수료</v-tab
          ><v-tab
            :class="tab_class"
            :ripple="false"
            value="4"
            :disabled="!this.home.is_display_balance_info"
            v-if="!isOptionOnlyVillage"
            >잔금납부 안내</v-tab
          >
        </v-tabs>
        <v-divider></v-divider>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <div class="tab-contents">
              <div v-if="tab_id == 'status'">
                <div class="tabs-box">
                  <ul class="tab-menu">
                    <li v-bind:class="{ active2: sub_tab_id == 'sell' }" v-if="!isOptionOnlyVillage">
                      <router-link to="/contractInfo/status/sell">분양계약</router-link>
                    </li>
                    <li
                      v-bind:class="{
                        active2: sub_tab_id === 'option',
                      }"
                    >
                      <router-link to="/contractInfo/status/option"
                        >별도계약품목</router-link
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <div v-show="tab_id == 'status' && sub_tab_id == 'sell'">
                <StatusForSell />
                <WarMes :number="customerSupportTelephone" />
              </div>
              <div v-show="tab_id == 'status' && sub_tab_id == 'option'">
                <Options />
                <WarMes :number="customerSupportTelephone" />
              </div>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="tab-contents">
              <div v-if="tab_id == 'payment'">
                <div class="tabs-box">
                  <ul class="tab-menu">
                    <li
                      v-bind:class="{
                        active2: sub_tab_id === 'payment',
                      }"
                      v-if="!isOptionOnlyVillage"
                    >
                      <router-link to="/contractInfo/payment/payment"
                        >분양대금</router-link
                      >
                    </li>
                    <li
                      v-bind:class="{
                        active2: sub_tab_id === 'option',
                      }"
                    >
                      <router-link to="/contractInfo/payment/option"
                        >별도계약품목</router-link
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <div v-if="tab_id == 'payment' && sub_tab_id == 'payment'">
                <Payment />
                <WarMes :number="customerSupportTelephone" />
              </div>
              <div v-if="tab_id == 'payment' && sub_tab_id == 'option'">
                <OptionPayment />
                <WarMes :number="customerSupportTelephone" />
              </div>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="tab-contents">
              <div class="web-contbox" v-if="tab_id == 'loan' && sub_tab_id == 'loan'">
                <Loan />
                <WarMes :number="customerSupportTelephone" />
              </div>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="tab-contents">
              <div
                class="web-contbox"
                v-if="tab_id == 'interest' && sub_tab_id == 'interest'"
              >
                <LoanInterest />
                <WarMes :number="customerSupportTelephone" />
              </div>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="tab-contents">
              <div
                class="web-contbox"
                v-if="tab_id == 'balance' && sub_tab_id == 'balance'"
              >
                <BalancePayment />
                <WarMes :number="customerSupportTelephone" />
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-container>

    <!-- 임대 -->
    <v-container class="pd0 ps-re" v-else>
      <div class="tabs-box">
        <v-tabs
          color="black"
          height="37px"
          style="font-size: 14px"
          v-model="tab"
          background-color="white"
        >
          <v-tab :class="tab_class" :ripple="false">계약정보 조회</v-tab>
          <v-tab :class="tab_class" :ripple="false">보증금·임대료 조회</v-tab>
          <v-tab :class="tab_class" :ripple="false" v-if="showRentProjectMenu">전자서명 조회</v-tab>
          <v-tab :class="tab_class" :ripple="false" v-if="showRentProjectMenu">자동출금 조회</v-tab>
          <v-tab :class="tab_class" :ripple="false" v-if="showRentProjectMenu">렌트프리 조회</v-tab>
          <v-tab
            :class="tab_class"
            :ripple="false"
            v-if="home.erp_village_id == 'AA00P0267D'"
            >융자현황 조회</v-tab
          >
          <v-tab
            :class="tab_class"
            :ripple="false"
            v-if="home.erp_village_id == 'AA00P0267D'"
            >대납이자·보증수수료</v-tab
          >
          <v-tab
            :class="tab_class"
            :ripple="false"
            v-if="home.contract_reservation.CHANGE"
            >계약변경 방문예약</v-tab
          >
          <v-tab :class="tab_class" :ripple="false" v-if="home.contract_reservation.RENEW"
            >계약갱신 방문예약</v-tab
          >
          <v-tab
            :class="tab_class"
            :ripple="false"
            v-if="home.contract_reservation.TERMINATE_BEFORE_CONTRACT"
            >계약 해지 방문예약</v-tab
          ><v-tab
            :class="tab_class"
            :ripple="false"
            v-if="home.contract_reservation.TERMINATE_BEFORE_PERIOD"
            >중도 퇴거 신청</v-tab
          >
          <v-tab
            :class="tab_class"
            :ripple="false"
            v-if="home.contract_reservation.TERMINATE_ON_PERIOD"
            >만기 퇴거 신청</v-tab
          >
        </v-tabs>
        <v-divider></v-divider>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <div class="tab-contents">
              <div class="web-contbox" v-if="tab_id == 'status'">
                <StatusForRent />
                <WarMes :number="customerSupportTelephone" />
              </div>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="tab-contents">
              <div v-if="tab_id == 'receipt'">
                <div class="tabs-box">
                  <ul class="tab-menu">
                    <li
                      v-bind:class="{
                        active2: sub_tab_id == 'deposit',
                      }"
                    >
                      <router-link to="/contractInfo/receipt/deposit"
                        >보증금 납부/미납 내역</router-link
                      >
                    </li>
                    <li
                      v-bind:class="{
                        active2: sub_tab_id == 'leasePayment',
                      }"
                    >
                      <router-link to="/contractInfo/receipt/leasePayment"
                        >임대료 납부/미납 내역</router-link
                      >
                    </li>
                  </ul>
                </div>
                <div class="tab-contents">
                  <div v-if="sub_tab_id == 'deposit'">
                    <Deposit />
                    <WarMes :number="customerSupportTelephone" />
                  </div>
                  <div v-if="sub_tab_id == 'leasePayment'">
                    <LeasePayment />
                    <WarMes :number="customerSupportTelephone" />
                  </div>
                </div>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item v-if="showRentProjectMenu">
            <div class="tab-contents">
              <div class="web-contbox" v-if="tab_id == 'modusign' && sub_tab_id == 'modusign'">
                <ModusignList />
                <WarMes :number="customerSupportTelephone" />
              </div>
            </div>
          </v-tab-item>
          <v-tab-item v-if="showRentProjectMenu">
            <div class="tab-contents">
              <div class="web-contbox" v-if="tab_id == 'autoWithdraw' && sub_tab_id == 'autoWithdraw'">
                <AutoWithdrawInfo />
                <WarMes :number="customerSupportTelephone" />
              </div>
            </div>
          </v-tab-item>
          <v-tab-item v-if="showRentProjectMenu">
            <div class="tab-contents">
              <div class="web-contbox" v-if="tab_id == 'rentFree' && sub_tab_id == 'rentFree'">
                <RentFreeList />
                <WarMes :number="customerSupportTelephone" />
              </div>
            </div>
          </v-tab-item>
          <v-tab-item v-if="home.erp_village_id == 'AA00P0267D'">
            <div class="tab-contents">
              <div class="web-contbox" v-if="tab_id == 'loan' && sub_tab_id == 'loan'">
                <Loan />
                <WarMes :number="customerSupportTelephone" />
              </div>
            </div>
          </v-tab-item>
          <v-tab-item v-if="home.erp_village_id == 'AA00P0267D'">
            <div class="tab-contents">
              <div
                class="web-contbox"
                v-if="tab_id == 'interest' && sub_tab_id == 'interest'"
              >
                <LoanInterest />
                <WarMes :number="customerSupportTelephone" />
              </div>
            </div>
          </v-tab-item>
          <v-tab-item v-if="home.contract_reservation.CHANGE">
            <div class="tab-contents">
              <div class="web-contbox" v-if="tab_id == 'request'">
                <ContractChange />
                <WarMes :number="customerSupportTelephone" />
              </div>
            </div>
          </v-tab-item>
          <v-tab-item v-if="home.contract_reservation.RENEW">
            <div class="tab-contents">
              <div class="web-contbox" v-if="tab_id == 'renew'">
                <ContractRenewal />
                <WarMes :number="customerSupportTelephone" />
              </div>
            </div>
          </v-tab-item>
          <v-tab-item v-if="home.contract_reservation.TERMINATE_BEFORE_CONTRACT">
            <div class="tab-contents">
              <div class="web-contbox" v-if="tab_id == 'cancel'">
                <ContractCancel />
                <WarMes :number="customerSupportTelephone" />
              </div>
            </div>
          </v-tab-item>
          <v-tab-item v-if="home.contract_reservation.TERMINATE_BEFORE_PERIOD">
            <div class="tab-contents">
              <div class="web-contbox" v-if="tab_id == 'before'">
                <LeaveBefore />
                <WarMes :number="customerSupportTelephone" />
              </div>
            </div>
          </v-tab-item>
          <v-tab-item v-if="home.contract_reservation.TERMINATE_ON_PERIOD">
            <div class="tab-contents">
              <div class="web-contbox" v-if="tab_id == 'on'">
                <LeaveOn />
                <WarMes :number="customerSupportTelephone" />
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-container>
  </v-container>
</template>

<style>
.sel-cus .v-text-field__details {
  min-height: auto;
}

.sel-cus .v-input__slot {
  margin: 0;
}

.sel-cus .v-input input {
  max-height: 40px;
}

.sel-cus .v-input .v-label {
  text-align: center;
}

.sel-cus .v-select__selection {
  max-width: 100%;
  width: 100%;
  padding-left: 28px;
  text-align: center;
}

.v-slide-group__prev {
  display: none !important;
}
</style>

<script>
import { getContract } from "@/api/contract";
import Weblogo from "@/assets/images/common/new-logo.svg";
import Back from "@/assets/images/icon/icon-back.svg";
import AutoWithdrawInfo from "@/components/Contract/AutoWithdrawInfo.vue";
import BalancePayment from "@/components/Contract/BalancePayment";
import ContractCancel from "@/components/Contract/ContractCancel";
import ContractChange from "@/components/Contract/ContractChange";
import ContractRenewal from "@/components/Contract/ContractRenewal";
import Deposit from "@/components/Contract/Deposit";
import LeasePayment from "@/components/Contract/LeasePayment";
import LeaveBefore from "@/components/Contract/LeaveBefore";
import LeaveOn from "@/components/Contract/LeaveOn";
import Loan from "@/components/Contract/Loan";
import LoanInterest from "@/components/Contract/LoanInterest";
import ModusignList from "@/components/Contract/ModusignList.vue";
import OptionPayment from "@/components/Contract/OptionPayment";
import Options from "@/components/Contract/Options";
import Payment from "@/components/Contract/Payment";
import RentFreeList from "@/components/Contract/RentFreeList.vue";
import StatusForRent from "@/components/Contract/StatusForRent";
import StatusForSell from "@/components/Contract/StatusForSell";
import WarMes from "@/components/Contract/WarningMess";

export default {
  components: {
    StatusForSell, //계약 현황 - 분양계약정보.
    Options, //계약 현황 - 분양 별도계약품목
    Payment, //수납현황 - 중도금납부조회,
    OptionPayment, //수납현황 - 별도품목납부조회
    Loan,
    LoanInterest,
    BalancePayment,
    Deposit,
    StatusForRent, // 계약 현황 - 임대 계약정보
    LeasePayment, // 보증금/임대료 - 임대료 납부/미납 내역
    ContractChange,
    ContractRenewal,
    ContractCancel,
    LeaveBefore,
    LeaveOn,
    Back,
    WarMes, // 주의사항 메세지
    Weblogo,
    ModusignList, // 모두사인 리스트 조회
    AutoWithdrawInfo, // 자동출금 동의정보/출금내역 조회
    RentFreeList, // 렌트프리 내역 조회
  },
  name: "ContractInfo",
  data() {
    return {
      tab: 0,
      tab_class: "tab-sizebox",
      customerSupportTelephone: "",

      tab_array: ["status", "payment", "loan", "interest", "balance"],
      path: [
        "/contractInfo/status/sell",
        "/contractInfo/payment/payment",
        "/contractInfo/loan/loan",
        "/contractInfo/interest/interest",
        "/contractInfo/balance/balance",
      ],
    };
  },
  watch: {
    $route(to, from) {
      this.tabSync(to);
    },
    tab(val) {
      if (this.home.is_rent) {
        this.moveTo(this.rent_path[val]);
      } else {
        if (this.isOptionOnlyVillage && (val == 0 || val ==1)) {
          if (val == 0){

            this.moveTo("/contractInfo/status/option");
          }else if (val== 1){
            this.moveTo("/contractInfo/payment/option");
          }
        } else {
          this.moveTo(this.path[val]);
        }
      }
    },
  },
  methods: {
    getContractVillages() {},
    moveTo(path) {
      // aviod current route
      if (this.$route.path === path) return;
      this.$router.push({ path: path });
    },
    tabSync(to) {
      if (this.home.is_rent) {
        this.tab = this.tab_rent_array.indexOf(to.params.tab_id);
      } else {
        this.tab = this.tab_array.indexOf(to.params.tab_id);
      }
    },
    getContractAPI() {
      getContract(this.home.id).then((res) => {
        this.customerSupportTelephone = res.data.customerSupportTelephone;
      });
    },

  },
  computed: {
    is_development() {
      return process.env.NODE_ENV !== "production";
    },
    showRentProjectMenu(){
      /**
       * 임대프로젝트 통합테스트(운영)를 위해 테스트 단지만 메뉴 노출(TODO: 통합테스트 이후 삭제 예정)
       */
      if(this.is_development) return true;

      return this.home && (this.home.erp_village_id == "BQ00P0999D" || this.home.erp_village_id == "BQ00P0888D");
    },
    home() {
      return this.$store.getters.getHome ? this.$store.getters.getHome : {};
    },
    tab_id() {
      return this.$route.params.tab_id;
    },
    sub_tab_id() {
      return this.$route.params.sub_tab_id;
    },
    tab_rent_array() {
      var array = ["status", "receipt"];

      // 임대프로젝트 통합테스트를 위해 테스트 단지만 메뉴 노출(TODO: 통합테스트 이후 삭제 예정)
      if (this.showRentProjectMenu) array.push("modusign","autoWithdraw", "rentFree");

      if (this.home.erp_village_id == "AA00P0267D") array.push("loan");
      if (this.home.erp_village_id == "AA00P0267D") array.push("interest");
      if (this.home.contract_reservation.CHANGE) array.push("request");
      if (this.home.contract_reservation.RENEW) array.push("renew");
      if (this.home.contract_reservation.TERMINATE_BEFORE_CONTRACT) array.push("cancel");
      if (this.home.contract_reservation.TERMINATE_BEFORE_PERIOD) array.push("before");
      if (this.home.contract_reservation.TERMINATE_ON_PERIOD) array.push("on");

      return array;
    },
    rent_path() {
      var array = [
        "/contractInfo/status/rent",
        "/contractInfo/receipt/deposit",
      ];

      // TODO: 통합테스트 이후 삭제 예정
      if (this.showRentProjectMenu)
        array.push(
          "/contractInfo/modusign/modusign",
          "/contractInfo/autoWithdraw/autoWithdraw",
          "/contractInfo/rentFree/rentFree"
        );

      if (this.home.erp_village_id == "AA00P0267D")
        array.push("/contractInfo/loan/loan");
      if (this.home.erp_village_id == "AA00P0267D")
        array.push("/contractInfo/interest/interest");
      if (this.home.contract_reservation.CHANGE)
        array.push("/contractInfo/request/change");
      if (this.home.contract_reservation.RENEW) array.push("/contractInfo/renew/renew");
      if (this.home.contract_reservation.TERMINATE_BEFORE_CONTRACT)
        array.push("/contractInfo/cancel/cancel");
      if (this.home.contract_reservation.TERMINATE_BEFORE_PERIOD)
        array.push("/contractInfo/before/leave");
      if (this.home.contract_reservation.TERMINATE_ON_PERIOD)
        array.push("/contractInfo/on/leave");

      return array;
    },
    isOptionOnlyVillage() {
      return this.home && this.home.is_option_only_village;
    },
  },
  created() {
    this.getContractVillages();
    this.tabSync(this.$route);
    this.getContractAPI();

    if (this.isOptionOnlyVillage) {
      if (this.tab_id == "status" && this.sub_tab_id == "sell") {
        this.moveTo("/contractInfo/status/option");
      }else if (this.tab_id == "payment" && this.sub_tab_id == "payment") {
        this.moveTo("/contractInfo/payment/option");
      }
    }
  },
};
</script>
